export const TOAST_TIMEOUT = 1000;
